import { Link, Outlet, useLocation } from "react-router-dom"
import Dasboard from "../../../../../Components/Icons/Dasboard";
import { useEffect, useState } from "react";
import SearchBar from "../../../../../Components/Utils/SearchBar";
import { ClearFilterButton, CreateButton, FilterButton } from "../../../../../Components/Utils/Buttons";
import { Select } from "antd";
import { GetAccess } from "../../../../../Components/Utils/roles";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";


const PettyCashLayout = (
    {
        SearchData=() => {},
        setSearchQuery=()=>{},
        CreateAccess= true,
        ImportAccess= true,
        setOpen=()=>{},
        children,
        isFilter=false,
        newfilter=false,
        setFilterOpen=()=>{},
        ClearFilter=()=>{},
        officeId,
        projEctId,
        searchFun=()=>{},searchValue="",
    
    }
) =>{
    let {pathname} = useLocation()
    const [module,setModule] = useState("")
    

    useEffect(() =>{
        if(pathname == `/project/petty-cash/received/${officeId}/${projEctId}`){
            setModule("Received")
        }else if(pathname == `/project/petty-cash/issued/${officeId}/${projEctId}`){
            setModule("Issued")
        }
        // else if(pathname == "/progress/material-expense"){
        //     setModule("Material & Others")
        // }else if(pathname == "/progress/petty-cash-expense"){
        //     setModule("Petty Cash Expense")
        // }
    },[pathname])

    let LinkItem = [
        {
            label:"Received",
            link:`/project/petty-cash/received/${officeId}/${projEctId}`,
            access:GetAccess(),
        },
        {
            label:"Issued",
            link:`/project/petty-cash/issued/${officeId}/${projEctId}`,
            access:GetAccess(),
        },
        // {
        //     label:"Material & Others",
        //     link:"/progress/material-expense",
        //     access:true,
        // },
        // {
        //     label:"Petty Cash Expense",
        //     link:"/progress/petty-cash-expense",
        //     access:true,
        // }
    ]
    
    return(
        <div className=" w-full h-full py-2 px-4 ">
            <div className="">
            <div className="md:flex justify-end w-full">
            {/* <Breadcrumb items={[
                {
                    name:"Petty Cash"
                },
               
                {
                    name:module
                }
            ]} /> */}

<div className=" w-full h-8 flex items-center gap-x-4 ">
            {
                LinkItem && LinkItem.map((item, i) => {
                    return(
                        <>
                         {
                            item.access && (
                                // <Link to={item?.link} style={item?.link == pathname ?{borderBottom:"4px solid #119DEE"}:{borderBottom:"4px solid transparent"}} className={` pb-1 text-[13px] font-medium text-mainColor-400 hover:text-mainColor-400 ${item?.link == pathname ?"border-b-4 border-red":""}   `}  key={item?.link} >{item?.label||""}</Link>
                                <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>

                            )
                         }
                        </>
                    )
                })
            }
        </div>

            <div className=" flex justify-end items-center gap-3 mr-6">
            <form className="flex items-center gap-3 mx-0" onSubmit={SearchData}>
              <SearchBar handleChange={searchFun} value={searchValue}  />
              </form>
              {/* {ImportAccess && <CreateButton label="Import" handleClick={()=>setOpen(true)}    />} */}
              {/* <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
              {isFilter&& <FilterButton label='Clear Filter'  handleClick={ClearFilter} />} */}
              {newfilter && (
                          <>
                                      <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
                                      {isFilter&& <ClearFilterButton handleClick={ClearFilter} />} </>)}
            
              {CreateAccess && <Link to={`${pathname}/create`}><CreateButton label={module}/></Link>}
                  {/* <BackButton/> */}
                </div>
            </div>
           
           
           
            <div className=" w-full h-[calc(100vh-140px)] bg-white mt-2">
               {children} 
            </div>
            </div>
        </div>
    )
}


export default PettyCashLayout;